let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kfktb")).then(() => parcelRequire('lyfmv'));